export const mapWithJoin = <V>(
  arr: Array<V>,
  render: (v: any, i: number) => any,
  renderJoin: (v: any, i: number) => any,
): Array<any> =>
  arr.flatMap((e, i) =>
    arr.length !== i + 1 ? [render(e, i), renderJoin(e, i)] : render(e, i),
  )
